import { useEffect } from "react";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import TransferUserPackageForm from "./transfer-user-package-form";

const TransferUserPackage = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_TRANSFER_USER_PACKAGE",
      "DEVELOPER_TRANSFER_USER_PACKAGE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("TRANSFER_USER_PACKAGE")}
        subTitle={i18n.get("TRANSFER_USER_PACKAGE_SUB_TITLE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <TransferUserPackageForm />
    </ET3PageDiv>
  );
});

export default TransferUserPackage;
